import { useCallback } from 'react';
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import { InsertItemLayout } from '../InsertItemLayout/InsertItemLayout';
import { useAssetViewContext } from 'screens/editorial/asset/context/AssetViewContextProvider';
import { useAssetEditorsContext } from 'screens/editorial/asset/context/AssetEditorsContextProvider';

export const HammerOption = () => {
  const { setHammerHidden } = useAssetViewContext();
  const { hammerEditor } = useAssetEditorsContext();

  // reveal, scroll to, focus, and set cursor hammer
  const revealHammer = useCallback(() => {
    if (!hammerEditor) return;
    setHammerHidden(false);
    requestAnimationFrame(() => {
      hammerEditor.chain().focus().run();
    });
  }, [hammerEditor, setHammerHidden]);

  if (!hammerEditor) {
    return null;
  }

  return (
    <InsertItemLayout
      id="widget-select-hammer"
      title="Hammer"
      icon={<ViewHeadlineIcon />}
      description="A one or two-word identifier to provide an informal classification of the article."
      action={revealHammer}
    />
  );
};
